export const MENU_TYPES = [
  'main-menu-client-active',
  'main-menu-prospect',
  'afig-main-menu',
  'crg-main-menu',
  'footer-menu-prospect',
  'footer-menu-client-active',
  'footer-menu-client-expired'
] as const

export type MenuType = (typeof MENU_TYPES)[number]
